import config from "../config";
import { serviceInstance } from "../axiosInterceptor/requestHandler";

const depotService = {
  // GET REQUESTS

  getDepotWithAvaliableProduct: async (product) => {
    return await serviceInstance
      .get(
        `${config.baseurl}/Depot/DepotByProductName?productName=${
          product ?? ""
        } `
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  getDepotSettingsLog: async (data) => {
    return await serviceInstance
      .get(`${config.baseurl}/depot?status=${!data.status ? "" : data.status} `)
      .then(({ data, status }) => {
        return data;
      });
  },

  getDepotPriceChangeLog: async (data, pageData) => {
    const { startDate, endDate, depotId } = data ?? {}
    return await serviceInstance
      .get(
        `${config.baseurl}/Depot/PriceChangeLog?depotId=${depotId}&query=${pageData.query}&Page=${pageData.page}&PageLimit=${pageData.pageLimit}&StartDate=${startDate}&EndDate=${endDate}&range=5`
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  getDepotInventoryLog: async (data, pageData) => {
    const { startDate, endDate, depotId } = data;
    return await serviceInstance
      .get(
        `${config.baseurl}/Inventory/Depot/${depotId}/?StartDate=${startDate}&EndDate=${endDate}&query=${pageData.query}&Page=${pageData.page}&PageLimit=${pageData.pageLimit}&range=5`
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  // getDepotSettingsLog: async (data, pageData) => {
  getDepotSettingsLog: async (data) => {
    // const { startDate, endDate, depotId } = data;
    return await serviceInstance
      .get(
        `${config.baseurl}/FeatureControl/SettingControlLogs?control=Depot&id=${data.depotId}&range=5`
        // `${config.baseurl}/FeatureControl/SettingControlLogs/${depotId}/?StartDate=${startDate}&EndDate=${endDate}&query=${pageData.query}&Page=${pageData.page}&PageLimit=${pageData.pageLimit}`
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  getDepotOrders: async (data, pageData) => {
    return serviceInstance
      .get(
        `${config.baseurl}/DepotProductOrder/Depot/${data.id}?startDate=${data.startDate}&endDate=${data.endDate}&query=${pageData.query}&Page=${pageData.page}&PageLimit=${pageData.pageLimit}&range=5`
      )
      .then(({ data }) => data);
  },

  getDepotOverview: async (data) => {
    return await serviceInstance
      .get(`${config.baseurl}/Depot/Overview`)
      .then(({ data, status }) => {
        return data;
      });
  },

  getDepots: async (data) => {
    return await serviceInstance
      .get(`${config.baseurl}/depot?status=${!data.status ? "" : data.status} `)
      .then(({ data, status }) => {
        return data;
      });
  },

  getProductsByDepot: async (id) => {
    return await serviceInstance
      .get(`${config.baseurl}/Depot/ProductSaleCollection?depotId=${id}`)
      .then(({ data, status }) => {
        return data;
      });
  },

  getDepotsList: async () => {
    return await serviceInstance
      .get(`${config.baseurl}/depot?status=`)
      .then(({ data }) => {
        return data;
      });
  },

  getDepotGroups: async () => {
    return await serviceInstance
      .get(`${config.baseurl}/Depot/DepotGroupCollection`)
      .then(({ data, status }) => {
        return data;
      });
  },

  getDepotDetails: async (id) => {
    return serviceInstance
      .get(`${config.baseurl}/Depot/Single?id=${id}`)
      .then(({ data }) => data);
  },

  getDepotProducts: async (id) => {
    return serviceInstance
      .get(`${config.baseurl}/Depot/ProductSaleCollection?depotId=${id}`)
      .then(({ data }) => data);
  },

  getProducts: (request) =>
    serviceInstance
      .get(`${config.baseurl}/Depot/GetProducts`)
      .then(({ data, status }) => ({ ...data, status })),

  toggleProductStatus: (id) =>
    serviceInstance
      .get(`${config.baseurl}/Depot/ProductStatus/Toggle/${id}`)
      .then(({ data, status }) => ({ ...data, status })),

  // POST REQUESTS

  createDepts: (request) =>
    serviceInstance
      .post(`${config.baseurl}/Depot/Create`, request)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  createDepotGroup: (request) =>
    serviceInstance
      .post(`${config.baseurl}/Depot/CreateDepotGroup`, request)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  suspendDepot: async (data) => {
    return serviceInstance
      .post(`${config.baseurl}/Depot/UpdateStatus`, data)
      .then(({ data }) => data);
  },

  updateInventory: (request) =>
    serviceInstance
      .post(`${config.baseurl}/Inventory/Depot/UpdateMultiple`, request)
      .then(({ data, status }) => ({ ...data, status })),

  changeDepotPrice: (url, request) =>
    serviceInstance
      .post(`${config.baseurl}/${url}`, request)
      .then(({ data, status }) => ({ ...data, status })),

  mapDepotProducts: (request) =>
    serviceInstance
      .post(`${config.baseurl}/Depot/MapDepotProducts`, request)
      .then(({ data, status }) => ({ ...data, status })),

  //DELETE REQUESTS
  deleteDepot: async (payload) => {
    return serviceInstance
      .post(`${config.baseurl}/Depot/Delete`, payload)
      .then(({ data }) => data);
  },

  deleteProduct: async (id) => {
    return serviceInstance
      .delete(`${config.baseurl}/Depot/DeleteDepotProducts?productId=${id}`)
      .then(({ data }) => data);
  },

  //PUT REQUEST
  editDepot: async (depotid, payload) => {
    return serviceInstance
      .put(`${config.baseurl}/Depot/Edit?depotid=${depotid}`, payload)
      .then(({ data }) => ({ ...data, status }));
  },

  editProduct: async (productid, payload) => {
    return serviceInstance
      .put(
        `${config.baseurl}/Depot/EditDepotProducts?productid=${depotid}`,
        payload
      )
      .then(({ data }) => ({ ...data, status }));
  },
  deleteProductSale: (id) => {
    return serviceInstance
      .delete(`${config.baseurl}/Depot/DeleteProductSale?id=${id}`)
      .then(({ data }) => data);
  },
  editProductSale: (depotId, payload) => {
    return serviceInstance
      .put(
        `${config.baseurl}/Depot/EditProductSale?depotId=${depotId}`,
        payload
      )
      .then(({ data }) => data);
  },
};

export default depotService;
